import { cn } from "@/lib/utils/utils";

interface SectionSubHeadingProps {
  className?: string;
  subtitle?: string;
}

const SectionSubHeading = ({ className, subtitle }: SectionSubHeadingProps) => {
  return (
    <p className={cn("text-sm md:text-lg font-semibold mb-0", className)}>
      {subtitle}
    </p>
  );
};

export default SectionSubHeading;
